import React, { useState, useEffect } from "react";
import axios from "../Axios/Axios";
import { FaTimes } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Mughallogo from "../assets/Mughallogo.jfif";
import { FaSpinner } from "react-icons/fa";
import Swal from "sweetalert2";




export default function CustomerTable() {
  const [customers, setCustomers] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedCustomer, setEditedCustomer] = useState(null);

  

  const IMAGE_BASE_URL = `${axios.defaults.baseURL}/uploads/`;
  const IMAGE_BASE = `${axios.defaults.baseURL}/`;

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");
    try {
      setLoading(true);
      const res = await axios.get("/api/customers", {
        headers: { Authorization: `Bearer ${mughalsLoggedIn}` },
      });
      console.log(res)
      setCustomers(res.data);
    } catch (err) {
      setError("Failed to fetch customer data.");
    } finally {
      setLoading(false);
    }
  };

  const openModal = (customer, isEdit = false) => {
    setEditMode(isEdit);
    setModalData({ ...customer });
  };

  const closeModal = () => {
    setModalData(null);
    setIsEditing(false);
    setEditedCustomer(null);
  };


  const handleDelete = async (id) => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Customer will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#6fb104",
      cancelButtonColor: "#6fb104",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`/api/customers/${id}`, {
          headers: { Authorization: `Bearer ${mughalsLoggedIn}` },
        });
        Swal.fire("Deleted!", "Customer has been deleted.", "success");
        fetchCustomers();
      } catch (err) {
        Swal.fire("Error", "Delete failed", "error");
      }
    }
  };
  const handleUpdate = async () => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

    try {
      const res = await axios.put(`/api/customers/${editedCustomer._id}`, editedCustomer, {
        headers: { Authorization: `Bearer ${mughalsLoggedIn}` },
      });
      Swal.fire("Success", "Customer updated successfully", "success");
      closeModal();
      fetchCustomers();
      setCustomers((prev) =>
        prev.map((cust) =>
          cust._id === editedCustomer._id ? res.data : cust
        )
      );
    } catch (err) {
      Swal.fire("Error", "Failed to update customer", "error");
    }
  };

  const filteredCustomers = customers.filter((cust) => {
    const searchMatch =
      cust?.name?.toLowerCase().includes(search.toLowerCase()) ||
      cust?.NIC?.includes(search);
    const dateMatch = filterDate
      ? new Date(cust?.createdAt).toISOString().split("T")[0] === filterDate
      : true;
    return searchMatch && dateMatch;
  });

  return (


    <div style={{ overflowX: "hidden" }}>

      <h1 className="text-start mb-4 text-lemon" style={{  fontSize: 28 }}>
        Customer List
      </h1>

      {/* Filters */}
      <div className="row mb-3 p-2">
        <div className="col-md-6 mb-2">
          <input
            type="text"
            placeholder="Search..."
            className="form-control rounded-5 p-2"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-md-6 mb-2">
          <input
            type="date"
            className="form-control rounded-5 p-2"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>
      </div>

      {/* {loading && <p className="text-center">Loading...</p>}
      {error && <p className="text-danger text-center">{error}</p>} */}

       {/* Loader */}
              {loading && (
                <div className="d-flex justify-content-center my-5">
                  <FaSpinner className="spin" style={{ fontSize: 50, color: "#6fb104" }} />
                </div>
              )}

      {!loading && !error && (
        <div className="table-responsive p-2">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>CNIC</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map((cust) => (
                <tr key={cust._id}>
                  <td>
                    <img
                      src={cust.image ? `${IMAGE_BASE_URL}${cust.image}` : Mughallogo}
                      alt={cust?.name}
                      style={{ width: 50, height: 50, borderRadius: "50%" }}
                    />
                  </td>
                  <td>{cust?.name}</td>
                  <td>{cust?.NIC}</td>
                  <td>{new Date(cust?.createdAt).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn bg-lemon text-white me-2"
                      onClick={() => {
                        setModalData(cust);
                        setIsEditing(false);
                      }}
                    >
                      View
                    </button>

                    <button
                      className="btn bg-lemon text-white me-2"
                      onClick={() => {
                        setEditedCustomer(cust); 
                        setModalData(cust);
                        setIsEditing(true);
                      }}
                    >
                      Edit
                    </button>

                    <button className="btn bg-lemon text-white" onClick={() => handleDelete(cust._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {filteredCustomers.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    No matching records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {modalData && (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Edit Customer" : "Customer Details"}
                </h5>
                <button type="button" className="btn-close " onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                {isEditing ? (
                  <>
                    <div className="mb-3">
                      <label className="form-label fw-bold text-dark">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editedCustomer?.name}
                        onChange={(e) =>
                          setEditedCustomer({ ...editedCustomer, name: e.target.value })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold text-dark">CNIC</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editedCustomer?.NIC}
                        onChange={(e) =>
                          setEditedCustomer({ ...editedCustomer, NIC: e.target.value })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold text-dark">Licenses</label>
                      {editedCustomer?.licenses?.map((lic, index) => (
                        <div key={index} className="d-flex gap-2 mb-2">
                          <input
                            type="text"
                            placeholder="License Number"
                            className="form-control"
                            value={lic.licenseNumber}
                            onChange={(e) => {
                              const updated = [...editedCustomer?.licenses];
                              updated[index].licenseNumber = e.target.value;
                              setEditedCustomer({ ...editedCustomer, licenses: updated });
                            }}
                          />
                          <input
                            type="date"
                            className="form-control"
                            value={
                              lic.LicenseExpiryDate
                                ? new Date(lic.LicenseExpiryDate).toISOString().split("T")[0]
                                : ""
                            }
                            onChange={(e) => {
                              const updated = [...editedCustomer?.licenses];
                              updated[index].LicenseExpiryDate = e.target.value;
                              setEditedCustomer({ ...editedCustomer, licenses: updated });
                            }}
                          />
                          <button
                            className="btn bg-lemon text-white"
                            onClick={() => {
                              const updated = editedCustomer?.licenses.filter(
                                (_, i) => i !== index
                              );
                              setEditedCustomer({ ...editedCustomer, licenses: updated });
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                      <button
                        className="btn bg-lemon text-white mt-2"
                        onClick={() => {
                          const updated = [...editedCustomer?.licenses];
                          updated.push({ licenseNumber: "", LicenseExpiryDate: "" });
                          setEditedCustomer({ ...editedCustomer, licenses: updated });
                        }}
                      >
                        Add License
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-3">
                      <strong>Name:</strong> {modalData?.name}
                    </div>
                    <div className="mb-3">
                      <strong>CNIC:</strong> {modalData?.NIC}
                    </div>
                    <div className="mb-3">
                      <strong>Created At:</strong>{" "}
                      {new Date(modalData?.createdAt).toLocaleDateString()}
                    </div>
                    <div className="mb-3">
                      <strong>Licenses:</strong>
                      {modalData?.licenses?.length > 0 ? (
                        <ul className="mt-2" style={{ paddingLeft: 20, color: "#Customer List" }}>
                          {modalData?.licenses.map((lic) => (
                            <li key={lic._id}>
                              {lic.licenseNumber} - Expiry: {lic.LicenseExpiryDate}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted fst-italic">No licenses available</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <strong>Authority Letters:</strong>
                      {modalData?.authorityLetters?.filter(Boolean).length > 0 ? (
                        <div className="mt-2 row">
                          {modalData.authorityLetters
                            .filter(Boolean)
                            .map((letter, idx) => (
                              <div className="col-md-2 border m-2" key={idx}>
                                <div>
                                  <small>ExpDate: {new Date(letter.letterDate).toLocaleDateString()}</small>
                                </div>
                                {letter.image ? (
                                  <>
                                    <img
                                      src={`${IMAGE_BASE}${letter.image}`}
                                      alt="Authority Letter"
                                      style={{
                                        width: '100px',
                                        height: 'auto',
                                        borderRadius: '5px',
                                        marginTop: '5px',
                                      }}
                                    />
                                    <br />
                                    <a
                                      href={`${IMAGE_BASE}${letter.image}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ fontSize: '14px' }}
                                    >
                                      View Image
                                    </a>
                                  </>
                                ) : (
                                  <span className="text-danger">No Image Available</span>
                                )}
                              </div>
                            ))}
                        </div>
                      ) : (
                        <p className="text-muted fst-italic">No authority letters available</p>
                      )}
                    </div>

                  </>
                )}
              </div>
              <div className="modal-footer">
                {isEditing && (
                  <button className="btn bg-lemon text-white" onClick={handleUpdate}>
                    Save Changes
                  </button>
                )}
                <button className="btn bg-lemon text-white" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}